import { XmlSchemaFacet } from './XmlSchemaFacet';

export class XmlSchemaMinInclusiveFacet extends XmlSchemaFacet {}
